<template lang="pug">
div
  template(v-if="!pageLoading")
    .gbox(ref="container")
      #preloader(v-if="gameLaunching || favListAction")
        #loader
      //- .d-flex.align-items-center.position-relative.search-bar
        input.form-control(type="text" v-model="searchinput" placeholder="Search")
        img.position-absolute.search-img(src="assets/img/search-icon.png")
      div(v-if="!pageLoading")
        template(v-for="game in filteredList()")
          .ggl
            img.fav-icon.pointer(:src="getImg(game.game_code)" @click="favAction('TBL',game.game_code,game.game_name,'LIVE','assets/img/game_icon/TBL/'+game.game_code+'.png')")
            a(href="javascript:void(0)" @click="launchGame(game.game_code, game.game_name)")
              img.img-fluid.game-img(:src="'assets/img/game_icon/TBL/'+game.game_code+'.png'")
              span {{game.game_name}} 
            //- router-link(v-if="isLoggedIn" :to="'/launchTbl?game=' + game.game_code+'&name='+game.game_name" target="_blank")
            //-   img.img-fluid.game-img(:src="'assets/img/game_icon/TBL/'+game.game_code+'.png'")
            //-   span {{game.game_name}} 
            //- a(v-else href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
              img.img-fluid.game-img(:src="'assets/img/game_icon/TBL/'+game.game_code+'.png'")
              span {{game.game_name}} 
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [
        {game_code:"1",game_name: "Pinball Guessing" },
        {game_code:"4",game_name: "Bottle Cap Drifting"},
        {game_code:"5",game_name: "Mouse Looking For Home"}
      ],
      temp:[],
      items:[],
      offList:[],
      // searchinput: "",
      favListAction: false
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    },
    favList(){
      return this.$store.getters.getFavlist.filter((x)=>x.game_type === "LIVE")
    }
  },
  destroyed(){
    // window.removeEventListener('scroll', this.loadItems)
  },
  mounted(){
    window.scroll(0,0)
    this.getProviderGameOfflist()
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "TBL"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
              this.offList = response.data
              this.listToDisplay = [].concat(
                this.listToDisplay.filter(obj1 => this.offList.every(obj2 => obj1.KeyName !== obj2.game_code)),
                this.offList.filter(obj2 => this.gameList.every(obj1 => obj2.game_code !== obj1.KeyName))
              )
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        // this.getGameList()
      }
    },
    launchGame(game, name){
      if (this.sessionToken) {
        this.$router.push({
          name:"lobby",
          params:{
            "source": "casino",
            "type": "LIVE",
            "provider": 6,
            "code": "TBL",
            "id": game,
            "name": name
          }
        }).catch(error =>{})
      }else{
        $("#logModal").modal("show")
      }
    },
    filteredList(){
      return this.listToDisplay.filter((game) =>
        game.game_name.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
    favAction(provider,game,name,type,img){
      if (this.sessionToken) {
        if(this.favList.some(obj=> obj.game_code === game)){
          this.removeFav(provider, game)
        }else{
          this.addFav(provider,game,name,type,img)
        }
      }else{
        $("#logModal").modal("show")
      }
    },
    addFav(provider,game,name,type,img){
      if (this.sessionToken) {
        this.favListAction = true
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let game_name = name
        let provider_code = provider
        let game_type = type
        let img_url = img
        this.$store
          .dispatch("user/addFav", { account_id, auth_token,game_code, game_name, provider_code, game_type, img_url })
          .then(response => {
            if (response.success == true) {
              // console.log(response)
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    removeFav(provider, game){
      if (this.sessionToken) {
        this.favListAction = true
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              // this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    getImg(code){
      if(this.favList.some(obj=> obj.game_code === code)){
        return "assets/img/fav-s.png"
      }else{
        return "assets/img/fav.png"
      }
      // 
    },
    getFavlist(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              // console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
  }
}
</script>
